module.exports = __webpack_public_path__ + "img/Taiwan-3-hover.b7fa24c5.jpg";